import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClaimLeavesList } from '../../../store/claimLeaves/claimLeavesActions';
import styles from './style.module.scss';

export const RLList = () => {
  const dispatch = useDispatch();
  const { claimLeaves } = useSelector(s => s.claimLeaves);

  useEffect(() => {
    dispatch(fetchClaimLeavesList());
  }, []);

  return (
    <>
      {claimLeaves?.length > 0 && (
        <div className={styles['rl-section']}>
          <div className={styles['title']}>Expiring RL/CF</div>
          <div className={styles['rl-list']}>
            <div className={styles['rl-item-header']}>
              <div className={styles['rl-item-header-title']}>Type</div>
              <div className={styles['rl-item-header-title']}>OT Date/Hours</div>
              <div className={styles['rl-item-header-title']}>Expiry Date</div>
            </div>
            {claimLeaves.map(record => (
              <div key={record.RecId} className={styles['rl-item']}>
                <div className={styles['rl-item-title']}>{record.Type}</div>
                <div className={styles['rl-item-title']}>
                  {record.ClaimDate} ({record.Hours - record.UtilizedHours} hours)
                </div>
                <div className={styles['rl-item-date']}>{record.ExpiryDate}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
